var TtfNameTable = /** @class */ (function () {
    function TtfNameTable() {
    }
    return TtfNameTable;
}());
export { TtfNameTable };
